export const clamp = (value, min, max) => Math.max(min, Math.min(max, value));

export const lerp = (a, b, t) => a + (b - a) * t;

/** Frame-rate independent smoothing. `lambda` is roughly "how fast". */
export const damp = (current, target, lambda, dt) =>
  lerp(current, target, 1 - Math.exp(-lambda * dt));

/** Shortest signed angle from `from` to `to`, in radians. */
export const shortestAngle = (from, to) => {
  let delta = (to - from) % (Math.PI * 2);
  if (delta > Math.PI) delta -= Math.PI * 2;
  if (delta < -Math.PI) delta += Math.PI * 2;
  return delta;
};

export const dampAngle = (current, target, lambda, dt) =>
  current + shortestAngle(current, target) * (1 - Math.exp(-lambda * dt));
